import { useEntity, IndexContainer } from 'components';
import type { Enterprise, MembershipLog as MembershipLogType } from 'modules/core/types';
import { timestamp } from 'components/columns';
import { ReactElement } from 'react';
import { ListExport } from 'components/ListActions';
import { ControlledTableColumns, flexColumn } from 'components/ControlledTable';

const columns: ControlledTableColumns<MembershipLogType> = [
  {
    content: 'Id',
    key: 'membership_id',
    required: true,
    width: 80,
  },
  flexColumn({
    content: 'User',
    key: 'user_repr',
  }),
  timestamp('Created', 'date_from', { sortable: true, width: 140 }),
  flexColumn({
    content: 'Created by',
    key: 'created_by_repr',
  }),
  timestamp('Removed', 'date_to', { sortable: true, width: 140 }),
  flexColumn({
    content: 'Removed by',
    key: 'removed_by_repr',
  }),
];

export function MembershipLog(): ReactElement {
  const { endpoint: entityEndpoint } = useEntity<Enterprise>();
  const endpoint = `${entityEndpoint}membership_log/`;

  return (
    <IndexContainer
      title="Membership log"
      url={endpoint}
      columns={columns}
      toolbar={<ListExport endpoint={`${endpoint}export/`} />}
    />
  );
}
